import styled from "styled-components";

export const CrossBrandsItemsAboveSearchBox = styled.div<{totalItems: number}>`
    display: grid;
    grid-template-columns: repeat(${({totalItems}) => totalItems}, 1fr);
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
    margin: 1rem 0 0;
`;